export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14283.8ce091ce.jpg";